import React from 'react';
import PropTypes from 'prop-types';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';

const AuditSubTable = ({ displayData }) => {
  const hdrSortClasses = (_column, sortOrder) => `sorting_${sortOrder}`;

  const columns = [
    {
      dataField: 'TransactionID',
      text: 'ID',
      hidden: true,
    },
    {
      dataField: 'ChangeTimeStamp',
      text: 'Date',
      hidden: true,
    },
    {
      dataField: 'Transactiontype',
      text: 'Type',
      hidden: true,
    },
    {
      dataField: 'RealUser',
      text: 'Changed By',
      hidden: true,
    },
    {
      dataField: 'ImpersonatedUser',
      text: 'Impersonating',
      hidden: true,
    },
    {
      dataField: 'RecordUniqueID',
      text: 'ID',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '10%' },
    },
    {
      dataField: 'ClassName',
      text: 'Field Type',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '15%' },
    },
    {
      dataField: 'FieldName',
      text: 'Field Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '25%' },
    },
    {
      dataField: 'OldValue',
      text: 'Changed From',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '25%' },
      classes: 'text-danger',
    },
    {
      dataField: 'NewValue',
      text: 'Changed To',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '25%' },
      classes: 'text-success',
    },
  ];

  const defaultSorted = [{
    dataField: 'RecordUniqueID',
    order: 'desc',
  }];

  const paginationOptions = {
    sizePerPage: 9999,
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    paginationTotalRenderer: (from, to, size) => (
      <div className="pagination-total">{`Showing rows ${from} to ${to} of ${size}`}</div>
    ),
    showTotal: true,
  };

  return (
    <ToolkitProvider
      keyField="UniqueId"
      data={displayData}
      columns={columns}
      search
    >
      { toolKit => (
        <div className="dataTables_wrapper dt-bootstrap4 no-footer">
          {
            displayData && (
              <>
                <BootstrapTable
                  data={displayData}
                  defaultSorted={defaultSorted}
                  wrapperClasses="table-responsive"
                  classes="dataTable subtable"
                  bordered={false}
                  striped
                  hover
                  noDataIndication="No Data Returned."
                  pagination={displayData.length > 1 ? paginationFactory(paginationOptions) : null}
                  {...toolKit.baseProps}
                />
              </>
            )
          }
        </div>
      )}
    </ToolkitProvider>
  );
};

AuditSubTable.propTypes = {
  displayData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default AuditSubTable;
